export class LocationPermissionError extends Error {

}